const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be`, `f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be`, 1, 10), undefined, true, false, 1));
            }

            getTemplateName() {
                return `f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be`;
            }

            getSourceContext() {
                return new this.Source(``, `f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be`, ``);
            }
        }],
        [10, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/ground-nav/ground-nav.twig`, `f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be`, 1);

                this.blocks = new Map([
                    ['kudos', [this, 'block_kudos']],
                    ['legal', [this, 'block_legal']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/ground-nav/ground-nav.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_kudos(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p class="c-ground-nav__kudos">
      Hosted by <a href="https://www.netlify.com/">Netlify</a>, inspired by <a href="https://wpostats.com/">WPO Stats</a> and <a href="https://developers.google.com/web/showcase/">Google Web Showcase</a>
    </p>
  `);
            }

            block_legal(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p class="c-ground-nav__legal">
      Designed by Cloud Four (<a href="https://github.com/cloudfour/pwastats/blob/main/LICENSE">License</a>)
    </p>
  `);
            }

            getTemplateName() {
                return `f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be');

let template = env.loadTemplate('f3721f4680f1e24430d1f20bbcfa93fc7acf6ce8637a0b5c625adf2a9aae71be');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/ground-nav/demo/pwa-stats.twig", args: context }
     );
     return rendered;;
};